import React, { useState } from "react";
import styled from "styled-components";
import PlayerInfo from "../playerInfo/playerInfo";
import { Button, Modal, Select, Radio } from 'antd';

import "antd/dist/antd.css";

import { useStore } from 'react-context-hook';

const { Option } = Select;

const ControlWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 16px;
`;

const SelectActionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin: 2px
`;

const PlayerControlWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 16px;
`;

const StyledButton = styled(Button)`
    margin: 2px;
`;

const PASS_ACTION_NUMBER = 65
const GRAND_TICHU_ACTION_NUMBER = 69
const TICHU_ACTION_NUMBER = 67

const GIVE_DRAGON_ACTION_NUMBER = 72


const PlayerControls = ({ player, socket, handCards }) => {
    const [gameState, ] = useStore('game', {});

    const [choosePhoenix, setChoosePhoenix] = useStore('choose_phoenix', []);

    const { possibleActions, currentPlayer } = gameState;


    const [selectedAction, setAction] = useState(undefined);

    const [wishAction, setWishAction] = useState(0);

    const [phoenixRankIndex, setPhoenixRankIndex] = useState(0);

    const [buttonLoading, setButtonLoading] = useState(false);

    const playersTurn = currentPlayer === player;

    const passActionAllowed = (possibleActions.filter(item => item.number === PASS_ACTION_NUMBER).length > 0);

    const wishActionAllowed = playersTurn && possibleActions[0].number === 0;

    const grandTichuActionAllowed = playersTurn && possibleActions[0].number === GRAND_TICHU_ACTION_NUMBER;

    const tichuActionAllowed = playersTurn && (possibleActions[0].number === TICHU_ACTION_NUMBER || possibleActions[0].number === TICHU_ACTION_NUMBER + 1);

    const passDragonActionAllowed = playersTurn && possibleActions[0].number === GIVE_DRAGON_ACTION_NUMBER;

    const tradeActionAllowed = playersTurn && possibleActions[0].number > 13 && possibleActions[0].number < 65;

    const choosePhoenixAllowed = playersTurn && (choosePhoenix.length > 0);

    const onNext = () => {
        setButtonLoading(true);
        socket.emit('next_action', {action: selectedAction});
        setAction(undefined);
        setButtonLoading(false);
    };

    const onPass = () => {
        socket.emit('next_action', {action: PASS_ACTION_NUMBER});
        setAction(undefined);
    };

    const onWish = () => {
        socket.emit('next_action', {action: wishAction});
        setAction(undefined);
    };

    const onAction = (action) => {
        socket.emit('next_action', {action: action});
        setAction(undefined);
    };

    const onChoosePhoenix = () => {
        socket.emit('choose_phoenix_rank', {rank_index: phoenixRankIndex});
        setChoosePhoenix([]);
    };

    const onActionSwitch = (value) => {
        setAction(value);
    };

    const wishActions = ["None", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K", "A"]

    return (
        <ControlWrapper>
            <PlayerInfo player={player}/>
            {/*<PlayerControlWrapper>*/}
                {/*<SelectActionWrapper>*/}
                {/*    <Select disabled={!playersTurn} value={selectedAction} placeholder="Select an action" style={{ width: 320 }} onChange={onActionSwitch}>*/}
                {/*        {possibleActions.map((action) => (*/}
                {/*            <Option key={action.number} value={action.number}>{action.action}</Option>*/}
                {/*        ))}*/}
                {/*    </Select>*/}
                {/*    <Button loading={buttonLoading} type="primary" disabled={!playersTurn || !selectedAction} onClick={onNext}>Play Action</Button>*/}
                {/*</SelectActionWrapper>*/}
            {/*    <StyledButton type="primary" disabled={!playersTurn || !passActionAllowed} onClick={onPass}>Pass</StyledButton>*/}
            {/*</PlayerControlWrapper>*/}
            <Modal
                title="Phoenix As"
                closable={false}
                visible={choosePhoenixAllowed}
                okText="Choose"
                width={650}
                centered={true}
                maskClosable={false}
                cancelButtonProps={{ disabled: true }}
                onOk={onChoosePhoenix}
            >
                <Radio.Group defaultValue={phoenixRankIndex}
                             buttonStyle="solid"
                             onChange={(e) => setPhoenixRankIndex(e.target.value)}>
                    {choosePhoenix.map((value, index) => (
                        <Radio.Button value={index}>{value}</Radio.Button>
                    ))}
                </Radio.Group>
            </Modal>
            <Modal
                title="Wish"
                closable={false}
                visible={wishActionAllowed}
                okText="Wish"
                width={650}
                centered={true}
                maskClosable={false}
                cancelButtonProps={{ disabled: true }}
                onOk={onWish}
            >
                <Radio.Group defaultValue={wishAction}
                             buttonStyle="solid"
                             onChange={(e) => setWishAction(e.target.value)}>
                    {wishActions.map((value, index) => (
                        <Radio.Button value={index}>{value}</Radio.Button>
                    ))}
                </Radio.Group>
            </Modal>
            <Modal
                title="Trade Card"
                closable={false}
                visible={tradeActionAllowed}
                okText="Trade"
                width={650}
                centered={true}
                maskClosable={false}
                cancelButtonProps={{ disabled: true }}
                okButtonProps={{ disabled: !playersTurn || !selectedAction }}
                onOk={onNext}
            >
                <Select disabled={!playersTurn} value={selectedAction} placeholder="Select an action" style={{ width: 320 }} onChange={onActionSwitch}>
                    {possibleActions.map((action) => (
                        <Option key={action.number} value={action.number}>{action.action}</Option>
                    ))}
                </Select>
            </Modal>
            <Modal
                title="Call Grand Tichu"
                closable={false}
                maskClosable={false}
                centered={true}
                bodyStyle={{ display: "none"}}
                visible={grandTichuActionAllowed}
                okText="Yes"
                cancelText="No"
                onOk={() => onAction(GRAND_TICHU_ACTION_NUMBER)}
                onCancel={() => onAction(GRAND_TICHU_ACTION_NUMBER + 1)}
            />
            <Modal
                title="Call Tichu"
                closable={false}
                centered={true}
                bodyStyle={{ display: "none"}}
                maskClosable={false}
                visible={tichuActionAllowed}
                okText="Yes"
                cancelText="No"
                onOk={() => onAction(TICHU_ACTION_NUMBER)}
                onCancel={() => onAction(TICHU_ACTION_NUMBER + 1)}
            />
            <Modal
                title="Give Dragon Trick to Player"
                closable={false}
                centered={true}
                bodyStyle={{ display: "none"}}
                maskClosable={false}
                visible={passDragonActionAllowed}
                okText="Right"
                cancelText="Left"
                onOk={() => onAction(GIVE_DRAGON_ACTION_NUMBER + 1)}
                onCancel={() => onAction(GIVE_DRAGON_ACTION_NUMBER)}
            />
        </ControlWrapper>
    );
};

export default PlayerControls;